import { BaseSnackbarProvider } from '@certara/common-react-components';
import { useUIStore } from '@/stores/ui-store';

export function SnackbarProvider() {
  const setContactDialogOpen = useUIStore((state) => state.setContactDialogOpen);

  const handleContactSupport = () => {
    setContactDialogOpen(true);
  };

  return (
    <BaseSnackbarProvider
      onContactSupport={handleContactSupport}
      topOffset={64}
      stackSpacing={70}
    />
  );
}
